export const currencyToSymbolMap = new Map([
  ['PLZ', 'zł'], // This is old ISO 4217 for PLN (until 1995), therefore it can be deleted
  ['PLN', 'zł'],
  ['GBP', '£'],
  ['EUR', '€'],
  ['USD', '$'],
  ['HRK', 'kn'],
  ['BRL', 'R$'],
  ['MXN', 'MX$'],
  ['CAD', 'CA$'],
  ['CNY', 'CN¥'],
  ['CZK', 'Kč'],
  ['DKK', 'kr'],
  ['SEK', 'kr'],
  ['CHF', 'CHF'],
  ['DEM', 'DM'],
  ['ITL', 'L.'],
  ['FRF', 'Fr'],
  ['BEF', 'fr.'],
  ['LUF', 'F'],
  ['IEP', 'IR£'],
  ['NLG', 'ƒ'],
  ['RON', 'L'],
  ['BYN', 'Br'],
  ['RUN', '₽'],
  ['INR', '₹'],
  ['NZD', '$'],
  ['HKD', 'HK$'],
  ['MAD', 'Dh'],
])
